export const DELIVERYMETHODS = {
  GREENBILL: 'GREENBILL',
  ZOOMIT: 'ZOOMIT',
  BASWARE: 'BASWARE',
  PAPER: 'PAPER',
  PEPPOL: 'PEPPOL',
};

export const BRAND = {
  SCARLET: 'scarlet',
  PROXIMUS: 'proximus',
};

export const PAYMENTMETHODS = {
  DIRECTDEBIT: 'DD',
  CREDITCARD: 'CC',
};

export const INITIAL_DISPLAYABLE_CLOSED_TRANSACTIONS = 3;

export const IS_CALL_DETAILS_MODAL_OPEN_KEY = 'IS_CALL_DETAILS_MODAL_OPEN';

export const emailFormatRegEx =
  "^[A-Za-z0-9!#$%&amp;'*+\\/=?^_`{|}~.-]+@[A-Za-z0-9-]+(\\.[A-Za-z0-9-]+){1,2}$";

export const COVER_PAGE = '/cover';
export const COVER_NO_DETAILS_PAGE = '/coverNoDetails';
export const ONE_DIGITAL_BILL_CATEGORY_DETAILS_PAGE = '/odbCategoryDetails';
export const ONE_DIGITAL_BILL_USAGE_DET_L3_PAGE = '/usageL3';
export const ONE_DIGITAL_BILL_USAGE_DET_L4_PAGE = '/usageL4';
export const ODB_THIRD_PARTY_L3_PAGE = '/thirdPartyL3';
export const ODB_THIRD_PARTY_L4_PAGE = '/thirdPartyL4';

export const OVERVIEW_PAGE = '/overview';
export const BILL_OPTIONS_PAYMENT_FACILITIES_INFO =
  '/billOptionsPaymentFacilitiesInfo';
export const DEFERRAL_LANDING = '/deferralLanding';
export const DEFERRAL_SELECT_DATE_PAGE = '/deferralSelectDate';
export const DEFERRAL_ACCEPT_NEW_DATE = '/deferralAcceptNewDate';
export const DEFERRAL_SUCCESSFUL_NEW_DATE_PAGE = '/deferralSuccessfulNewDate';

export const EVOLUTION_PAGE = '/evolution';

export const SETTINGS_PAGE_TRANSLATION_KEY = 'bills.options.settingsLink';
export const SETTINGS_PAGE_LOGIN_REQUIRED_TRANSLATION_KEY =
  'bills.options.settingsLoginLink';

export const SMOOTH_AUTHENTICATION_SESSION_STORAGE_KEY = 'authentication';
export const BILL_AUTH_COOKIE_KEY = 'SAT';
export const BILL_AUTH_LAT_COOKIE_VALUE = '1';
export const BILL_AUTH_MPXS_COOKIE_VALUE = '0';
export const JWT_EXPIRED_TOKEN_CODE = 'EXPIRED_TOKEN';
export const USER_CALL_ERROR = 'message box error user';
export const BALANCE_CALL_ERROR = 'message box error billing-accounts-balances';
export const TAGGED_ERROR_KEY = 'TAGGED_ERROR_KEY';
export const BILLING_SERVICES_ERROR = 'billing-services-error';
